'use client'
import { useForm } from 'react-hook-form'
import { filterHypothesesResolver, filterHypothesesSelectors, useFilterHypothesesStore } from '../model'
import { Dto } from '../model/types/hypotheses-filter'
import Form from './form'
import { useEffect } from 'react'
import { Button } from '@/shared/ui/button'
import React from 'react'

const Div = () => <div></div>

export interface FormProps {
  onSubmit?: (dto: Dto) => void
  ContentWrapper?: React.ElementType
  FooterWrapper?: React.ElementType
}

export default function FormComponent({ ContentWrapper, FooterWrapper, ...rest }: FormProps) {
  const storeValues = useFilterHypothesesStore(filterHypothesesSelectors.selectValues)
  const storeStringValues = useFilterHypothesesStore(filterHypothesesSelectors.selectStringValues)
  const setStore = useFilterHypothesesStore(filterHypothesesSelectors.selectSetValues)
  const resetStore = useFilterHypothesesStore(filterHypothesesSelectors.selectClearValues)

  const form = useForm<Dto>({
    resolver: filterHypothesesResolver,
    defaultValues: storeValues,
  })

  async function onSubmit(values: Dto) {
    setStore({ values })
    rest?.onSubmit && rest.onSubmit(values)
  }

  useEffect(() => {
    const subscription = form.watch((v) => onSubmit(v as Dto))
    return () => subscription.unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.handleSubmit, form.watch])

  useEffect(() => {
    if (!storeStringValues) return
    const isDirty = Object.values(storeStringValues).some((item) => item)
    if (!isDirty) resetStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeStringValues])

  const resetForm = () => {
    const values = form.getValues()
    for (let name in values) {
      form.resetField(name as keyof typeof values, { defaultValue: [] })
    }
    resetStore()
  }

  const ContentWrapperSlot = ContentWrapper ? ContentWrapper : Div
  const FooterWrapperSlot = FooterWrapper ? FooterWrapper : Div

  return (
    <div>
      <ContentWrapperSlot>
        <Form {...form} />
      </ContentWrapperSlot>

      <FooterWrapperSlot>
        {!!storeValues && (
          <Button variant="destructive" onClick={resetForm}>
            Очистить фильтрацию
          </Button>
        )}
      </FooterWrapperSlot>
    </div>
  )
}
